import React from 'react';
import { getIcon } from '../../helpers/weather';

import styles from './weather.module.scss';

const WeatherBox = ({ weatherData }) => {
  const date = new Date();

  return (
    <div className={styles.wrapper}>
      <div className={styles.weather}>
        <h2 className={styles.weather__name}>
          Aktualna pogoda{' '}
          <div className={styles.weather__actual}>
            <img
              className={styles.weather__icon}
              src={`${process.env.PUBLIC_URL}/assets/img/weather/dark/${
                date.getHours() < Number(weatherData?.sunset?.split(':')[0]) &&
                date.getHours() > Number(weatherData?.sunrise?.split(':')[0])
                  ? 'day'
                  : 'night'
              }/${getIcon(weatherData.weatherCode)}`}
              alt="Ikona pogody"
            />
            <p className={styles.weather__temperature}>{weatherData.temperature}&deg;C</p>
          </div>
        </h2>
        <div className={styles.weather__box}>
          <ul className={styles.weather__column}>
            <li className={styles.weather__paragraph}>
              <img
                className={styles.weather__iconSmall}
                src={`${process.env.PUBLIC_URL}/assets/img/weather/navy/temperature.svg`}
                alt="Point icon"
              />
              <span className={styles.weather__text}>
                Temperatura odczuwalna:&nbsp;
                <span>{weatherData.perceivedTemperature}&deg;C</span>
              </span>
            </li>
            <li className={styles.weather__paragraph}>
              <img
                className={styles.weather__iconSmall}
                src={`${process.env.PUBLIC_URL}/assets/img/weather/navy/wind.svg`}
                alt="Point icon"
              />
              <span className={styles.weather__text}>
                Wiatr:&nbsp;
                <span>
                  {weatherData.windDirection}&nbsp;
                  {weatherData.windStrength}&nbsp;km/h
                </span>
              </span>
            </li>
            <li className={styles.weather__paragraph}>
              <img
                className={styles.weather__iconSmall}
                src={`${process.env.PUBLIC_URL}/assets/img/weather/navy/humidity.svg`}
                alt="Point icon"
              />
              <span className={styles.weather__text}>
                Wilgotność:&nbsp;<span>{weatherData.humidity}&nbsp;%</span>
              </span>
            </li>
            <li className={styles.weather__paragraph}>
              <img
                className={styles.weather__iconSmall}
                src={`${process.env.PUBLIC_URL}/assets/img/weather/navy/pressure.svg`}
                alt="Point icon"
              />
              <span className={styles.weather__text}>
                Cieśnienie:&nbsp;<span>{weatherData.atmosphericPressure} hPa</span>
              </span>
            </li>
            <li className={styles.weather__paragraph}>
              <img
                className={styles.weather__iconSmall}
                src={`${process.env.PUBLIC_URL}/assets/img/weather/navy/sunrise.svg`}
                alt="Point icon"
              />
              <span className={styles.weather__text}>
                Wsch. słońca:&nbsp;
                <span>{weatherData.sunrise}</span>
              </span>
            </li>
            <li className={styles.weather__paragraph}>
              <img
                className={styles.weather__iconSmall}
                src={`${process.env.PUBLIC_URL}/assets/img/weather/navy/sunset.svg`}
                alt="Point icon"
              />
              <span className={styles.weather__text}>
                Zach. słońca:&nbsp;<span>{weatherData.sunset}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WeatherBox;
